import { render, staticRenderFns } from "./threePartySDKManagement.vue?vue&type=template&id=67f307fc&scoped=true&"
import script from "./threePartySDKManagement.vue?vue&type=script&lang=js&"
export * from "./threePartySDKManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f307fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f307fc')) {
      api.createRecord('67f307fc', component.options)
    } else {
      api.reload('67f307fc', component.options)
    }
    module.hot.accept("./threePartySDKManagement.vue?vue&type=template&id=67f307fc&scoped=true&", function () {
      api.rerender('67f307fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/threePartySDKManagement.vue"
export default component.exports